import { render, staticRenderFns } from "./reference-header.vue?vue&type=template&id=660951d4&scoped=true&"
import script from "./reference-header.vue?vue&type=script&lang=js&"
export * from "./reference-header.vue?vue&type=script&lang=js&"
import style0 from "./reference-header.vue?vue&type=style&index=0&id=660951d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660951d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660951d4')) {
      api.createRecord('660951d4', component.options)
    } else {
      api.reload('660951d4', component.options)
    }
    module.hot.accept("./reference-header.vue?vue&type=template&id=660951d4&scoped=true&", function () {
      api.rerender('660951d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/references/reference-header.vue"
export default component.exports